import { Vue, Component, Prop } from "vue-property-decorator";
import * as ajax from "@brightspark/sparkling-ajax-js";

interface IMessage {
    title: string;
    link: string;
    iconLink: string;
    display: boolean;
}

interface IModel {
    articles: Array<IMessage>;
    slideSize: number;
    totalCount: number;
    dataUrl: string;
}

interface IComponentData {
    articles: Array<IMessage>;
    slidesAmount: number;
    slideElAmount: number;
    currentSlideNo: number,
    dataUrl: string;
    isDataRequestInProgress: boolean;
}

@Component
export default class MessageSlider extends Vue {
    @Prop() model: IModel;
    private _data: IComponentData;
    private SLIDER_INTERVAL = 3000;
    private _timeout: number | null = null;

    data() {
        for (let i = 0; i < this.model.articles.length; i++) {
            // initializing display property, so vue would recognize it
            this.model.articles[i].display = false;
        }

        return {
            articles: this.model.articles,
            currentSlideNo: 1,
            slideElAmount: this.model.slideSize,
            slidesAmount: Math.ceil(this.model.totalCount / this.model.slideSize),
            dataUrl: this.model.dataUrl
        };
    }

    mounted() {
        this.calculateVisibleElements();
        this.turnOnTimeout();
    }

    resetTimeout() {
        this.turnOffTimeout();
        this.turnOnTimeout();
    }

    turnOnTimeout() {
        var component = this;
        this._timeout = setTimeout(() => {
            component.slideForward();
            component.turnOnTimeout();
        }, this.SLIDER_INTERVAL);
    }

    turnOffTimeout() {
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
    }

    next() {
        this.turnOffTimeout();
        this.slideForward();
        this.turnOnTimeout();
    }

    prev() {
        this.turnOffTimeout();
        this.slideBackwards();
        this.turnOnTimeout();
    }

    slideBackwards() {

        if (this._data.isDataRequestInProgress) {
            return;
        }

        if (--this._data.currentSlideNo <= 0) {
            this._data.currentSlideNo = this._data.slidesAmount;
        }

        this.calculateVisibleElements();
    }

    slideForward() {
        
        if (this._data.isDataRequestInProgress) {
            return;
        }

        if (this._data.currentSlideNo++ >= this._data.slidesAmount) {
            this._data.currentSlideNo = 1;
        }

        this.calculateVisibleElements();
    }

    calculateVisibleElements() {
        let start = (this._data.currentSlideNo - 1) * this._data.slideElAmount;
        let end = start + this._data.slideElAmount;

        for (let i = 0; i < this._data.articles.length; i++) {
            this._data.articles[i].display = start <= i && end > i;
        }
    }

    get longestMessage(): IMessage {
        let longestArticle = this._data.articles[0];

        for (let i = 1; i < this._data.articles.length; i++) {
            if (longestArticle.title.length < this._data.articles[i].title.length) {
                longestArticle = this._data.articles[i];
            }
        }
        return longestArticle;
    }

    get nextButtonClass(): Array<string> {
        var classList = ["button button--secondary"];

        return classList;
    }

    get prevButtonClass(): Array<string> {
        var classList = ["button button--secondary-reverse"];

        return classList;
    }
}


// WEBPACK FOOTER //
// ./www/js/Components/MessageSlider/MessageSlider.ts